import type { ReactNode } from "react";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { paginaDeEntrada } from "../features/equipe/sessao";

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isTokenExpired = useAuthStore((state) => state.isTokenExpired);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const user = useAuthStore((state) => state.user);
  const { pathname } = useLocation();

  // O store é reidratado do localStorage de forma síncrona na criação e já
  // descarta sessão expirada, então aqui não existe estado de carregamento.
  // Esta checagem cobre o token que vence com a aba aberta.
  const expirado = isAuthenticated && isTokenExpired();

  useEffect(() => {
    if (expirado) clearAuth();
  }, [expirado, clearAuth]);

  if (!isAuthenticated || expirado) {
    return <Navigate to={paginaDeEntrada()} replace />;
  }

  // Equipe sem contrato escolhido: toda rota depende do painel do token. Sessão
  // de antes de 09/10/2026 tem cliente sem contrato e também volta para a escolha.
  if (user?.equipe && !user.idContrato && pathname !== "/equipe/contratos") {
    return <Navigate to="/equipe/contratos" replace />;
  }

  return <>{children}</>;
};

